module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "card",
    attrs: {
      "to": _vm.to
    }
  }, [_c('main', {
    staticClass: "card__main"
  }, [(_vm.cop_multi_name) ? _c('div', {
    staticClass: "card__copp"
  }, [_c('p', {
    staticClass: "multiCopText",
    attrs: {
      "title": "cop_multi_name"
    }
  }, [_vm._v(_vm._s(_vm.cop_multi_name))])]) : _vm._e(), _c('div', {
    staticClass: "card__vacancy"
  }, [_c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "center, bold, uppercase"
    }
  }, [_vm._v(_vm._s(_vm.vacancy))])], 1), (_vm.salary) ? _c('div', {
    staticClass: "card__salary"
  }, [_c('AppColorBadge', {
    attrs: {
      "mod": "blue"
    }
  }, [_c('AppText', {
    attrs: {
      "mod": "white"
    }
  }, [_vm._v(_vm._s(_vm.salary))])], 1)], 1) : _vm._e(), (_vm.organization) ? _c('div', {
    staticClass: "card__organization"
  }, [_c('AppHeading', {
    staticClass: "head_center",
    attrs: {
      "level": "3",
      "mod": "center, bold",
      "title": _vm.organization
    }
  }, [_vm._v(_vm._s(_vm.organization))])], 1) : _vm._e(), (_vm.organizationAddress) ? _c('div', {
    staticClass: "card__organizationAddress"
  }, [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "center"
    }
  }, [_vm._v(_vm._s(_vm.organizationAddress))])], 1) : _vm._e()]), _c('MoreButton', {
    staticClass: "card__btn"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77253e38","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/vacancies/card/Card.vue
// module id = 7a2ff10aff4ece9c79f0
// module chunks = 0